import { createContext } from "react";
import { AuthContext as ContextType } from "types/auth";

export const AuthContext = createContext<ContextType>({
    update: () => {},
    determined: false,
    username: 'not-defined',
    isAnonymous: true,
    user: undefined
})